import { PackagingType } from "../../../../../config/enums/PackagingType.enum";

export const PACKAGING_NAME_MAX_LENGTH = 32;
export const UNIT_SAVE_DEBOUNCE_MS = 1000;
export const PACKAGING_DEFAULT_CLICKED_UNIT = "baseUnit";
export const PACKAGING_TRANSPORT_FIELD = "numCases";

export const PACKAGING_SAVE_STATUS = {
  ADD: "add",
  EDIT: "edit"
} as const;

export type PackagingSaveStatus = (typeof PACKAGING_SAVE_STATUS)[keyof typeof PACKAGING_SAVE_STATUS];

export interface PackagingLevelMeta {
  title: string;
  label: string;
  type: string;
  name: string;
  badgePrefix: string;
  materialsSectionLabel: string;
  unitGateMessage: string;
}

export const getPackagingLevelMeta = (packagingType: PackagingType): PackagingLevelMeta | undefined => {
  switch (packagingType) {
    case PackagingType.SINGLE_UNIT_PACKAGING:
      return {
        title: "Base Unit Packaging",
        label: "Unit Size",
        type: "Base unit",
        name: "baseUnit",
        badgePrefix: "Unit",
        materialsSectionLabel: "PACKAGING MATERIALS",
        unitGateMessage: "Save unit size to add packaging materials."
      };
    case PackagingType.SALES_UNIT_PACKAGING:
      return {
        title: "Pack / Inner Pack Packaging",
        label: "Number of Base Units",
        type: "Pack",
        name: "numBaseUnit",
        badgePrefix: "Base Units",
        materialsSectionLabel: "PACKAGING MATERIALS",
        unitGateMessage: "Save number of base units to add packaging materials."
      };
    case PackagingType.BULK_UNIT_PACKAGING:
      return {
        title: "Case Packaging",
        label: "Number of Packs",
        type: "Case",
        name: "numPacks",
        badgePrefix: "Packs",
        materialsSectionLabel: "PACKAGING MATERIALS",
        unitGateMessage: "Save number of packs to add packaging materials."
      };
    case PackagingType.TRANSPORT_UNIT_PACKAGING:
      return {
        title: "Pallet Packaging",
        label: "Number of Cases",
        type: "Pallet",
        name: "numCases",
        badgePrefix: "Cases",
        materialsSectionLabel: "PACKAGING MATERIALS",
        unitGateMessage:
          "Save number of cases, pallet width, and pallet length to add packaging materials."
      };
    default:
      return undefined;
  }
};

export const isTransportUnitSaved = (
  unitSizes: number,
  palletWidth?: number,
  palletLength?: number
) => unitSizes > 0 && (palletWidth ?? 0) > 0 && (palletLength ?? 0) > 0;

export const isUnitSaved = (
  packagingType: PackagingType,
  unitSizes: number,
  palletWidth?: number,
  palletLength?: number
) => {
  if (packagingType === PackagingType.TRANSPORT_UNIT_PACKAGING) {
    return isTransportUnitSaved(unitSizes, palletWidth, palletLength);
  }
  return unitSizes > 0;
};
